<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>

    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title">{{ "glossary" | translate }}</h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="searchable-alphabets-wrapper">
          <div
            *ngFor="let letter of searchableAlphabets; let i = index"
            class="searchable-alphabet"
            [class.active]="activeAlphabetCriteriaIndex === i"
            [class.unavailable]="unavailableCharsArray.indexOf(letter) !== -1"
            (click)="setAlphabetCriteria(i)"
          >
            {{ letter }}
          </div>
        </div>
        <div class="terms-search-field-wrapper">
          <mat-form-field appearance="outline">
            <mat-label>{{"Search_for_terms" | translate }}</mat-label>
            <input
              #searchInput
              [(ngModel)]="searchTerm"
              matInput
              placeholder="{{ 'Search_for_terms' | translate }}"
            />
          </mat-form-field>
        </div>
        <div [class.hidden]="closeResultsCount" class="results-count-wrapper">
          <span
            >{{ totalTerms }}
            {{ totalTerms === 1 ? ('result' | translate) : ('results' | translate) }} {{"found" | translate }}</span
          >
          <span (click)="closeResultsCount = true" class="cursor-pointer"
            >X</span
          >
        </div>

        <div class="results-list-wrapper">
          <ng-container *ngIf="isSignificantTermsLoading">
            <div
              *ngFor="let paragraph of [0, 1, 2, 4]"
              class="loading-paragraph animate"
            ></div>
          </ng-container>
          <ng-container *ngIf="!isSignificantTermsLoading">
            <div
              *ngFor="let term of significantTerms"
              (click)="goToTermDetail(term.WordName)"
              class="term-details-wrapper 1 cursor-pointer"
            >
              <div class="terms-details">
                <div class="term-heading">
                  {{ term.WordName }}
                </div>
                <div class="term-tags">
                  <mat-chip-set
                    class="example-chip"
                    cdkDropListOrientation="horizontal"
                  >
                    <mat-chip
                      *ngFor="let attribute of fetchTags(term.Attributes)"
                      class="tag-box btn-sggs"
                      (click)="searchByHashtag(attribute,$event)"
                    >
                      {{ attribute }}
                    </mat-chip>
                  </mat-chip-set>
                </div>
                <div
                  class="term-description"
                  [innerHTML]="
                    showSmallerIntroductionString(term?.WordDescription)
                  "
                >
                  <!-- {{ term.WordDescription }} -->
                </div>
              </div>
              <div class="term-expand-wrapper">
                <div
                  (click)="goToTermDetail(term.WordName)"
                  class="term-expand-icon"
                >
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
       
      </div>
       <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
